<template>
      <v-card class="overflow-hidden v-card v-sheet theme--light mt-0" style="height:100%;">
        <!-- Alert Messages -->
        <div>
          <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
        </div>
        <loading 
          v-model:active="isLoading" 
          :can-cancel="true" 
          :is-full-page="fullPage" :color="primary_code">
        </loading>
        <!-- ######## Main page ######## -->
        <HeaderComponent :headerTitle="headerText" :router-link="{ name: action_from_reslogi === 'Reverse Logistics' || action_from_reslogi === 'FTA' ? 'ftaReverseLogistics' : 'ReturnCreationRia' }"
          :router-link-text="action_title" :return-condition="true" :component-name="return_sub_request_id">
        </HeaderComponent>
        <!-- <HeaderComponent :headerTitle="headerText" :IrrdDetails="IrrdDetails" :tagNumber="tagNumber"/> -->
        
        <!--  Success messeage popup -->
        <v-row justify="center">
          <v-dialog v-model="successpopup" persistent max-width="424px">
            <v-card class="v-card-100 mt-0">
              <v-card-title class="d-flex">
                <v-btn variant="solo" icon @click="successpopup = false" style="float:right;">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="text-center">
                <span> {{ successmessage }}</span>
              </v-card-text>
              <v-card-actions center>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mb-3 text-none" variant="flat" @click="afterClickOkLoadData">Ok</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- update popup for service partner/technician -->
        <v-row justify="center">
          <v-dialog v-model="updatepopinitem" persistent max-width="500px">
            <v-form>
            <v-card class="v-card-100 mt-0">
              <v-card class="v-card-100 mt-0">
                <v-card-title>
                  <span>Update</span>
                  <v-btn variant="solo" icon @click="closeItempopup" style="float:right;">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
              </v-card>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-combobox v-model="assign_to" :items="formattedAssignToItemsList" item-title="displayText" item-value="id" label="Assign To" variant="outlined" class="ma-2" v-on:keyup:enter="assignServicePartner"> </v-combobox>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions center>
                <v-spacer></v-spacer>
                <v-btn variant="outlined" class="cancel-color mb-3 text-none" @click="closeItempopup">Cancel</v-btn>
                <!-- <v-btn outlined class="submit-color mb-3" @click="writeOffItemSubmit" :disabled=" number >0 || !raise_note_against || !debit_amount">submit</v-btn> -->
                <v-btn color="primary" v-if="technician_flag === false" variant="flat" class="mb-3 text-none" @click="createServiceRequest" :disabled="!assign_to">Submit</v-btn>
                <v-btn color="primary" v-if="technician_flag === true" variant="flat" class="mb-3 text-none" @click="updateTechnician" :disabled="!assign_to">Submit</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-form>
          </v-dialog>
        </v-row>
        
        <!-- View Test Results Popup -->
        <v-row justify="center">
          <v-dialog v-model="datadetailpopuptestresults" items="return_items_data" persistent max-width="820px">
            <v-card class="v-card-100">
              <v-card class="v-card-100">
                <v-card-title>
                <v-row class="ma-1">
                  <span>Test Results</span>
                  <v-spacer></v-spacer>
                  <!-- <v-btn variant="solo" icon @click="closedatadetailpopuptestresults" class="pb=3" style="float:right;"> -->
                    <v-icon @click="closedatadetailpopuptestresults" class="pb=3">mdi-close</v-icon>
                    </v-row>
                  <!-- </v-btn> -->
                </v-card-title>
              </v-card>
              <v-card-text>
                <v-container>
                  <div>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Ticket Resolution</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        {{ return_items_data.ticket_resolution ?  return_items_data.ticket_resolution : "-" }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Item Decision</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        {{ return_items_data.item_decision ? return_items_data.item_decision[0].toUpperCase() + return_items_data.item_decision.slice(1) : "-" }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Inspection Questions</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <div v-if="return_items_data.condition_questions && return_items_data.condition_questions.length">
                          <ul>
                            <li style="list-style-type:none;" v-for="item in return_items_data.condition_questions" :key="item.question">
                              Q. {{ item.question }} : {{ item.answer }}
                            </li>
                          </ul>
                        </div>
                        <span v-else>-</span><br>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Estimated Service Cost</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" v-if="return_items_data.estimated_service_cost == 0">
                        {{return_items_data.estimated_service_cost}}
                      </v-col>
                      <v-col cols="6" sm="6" md="6" v-else-if="return_items_data.estimated_service_cost == null">
                        {{"-"}}
                      </v-col>
                      <v-col cols="6" sm="6" md="6" v-else>
                        {{return_items_data.estimated_service_cost}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Type Of Defect</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        {{ return_items_data.type_of_defect ?  return_items_data.type_of_defect : "-" }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Service Engineer Name</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <span>{{  return_items_data.service_partner_name ? return_items_data.service_partner_name : '-' }}</span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Defective Spare Parts Information</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <div v-if="return_items_data.defective_spare_part_info && return_items_data.defective_spare_part_info.length">
                          <li style="list-style-type:none;" v-for="spare_info in return_items_data.defective_spare_part_info">
                            {{ spare_info }}
                          </li>
                        </div>
                        <span v-else>-</span>
                        <br>
                      </v-col>
                    </v-row>
                  </div>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- View Test Results Popup -->
        <v-row justify="center">
          <v-dialog v-model="packagingConditionPopup" items="return_items_data" persistent max-width="720px">
            <v-card class="v-card-100">
              <v-card class="v-card-100 mt-0 custom-shadow">
                <v-card-title class="pa-0">
                  <v-row class="ma-2">
                  <span class="font-weight-bold">Grading Details</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="packagingConditionPopup = false">mdi-close</v-icon>
                </v-row>
                </v-card-title>
               </v-card>
              <v-card-text>
              <v-container class="pa-0">
                <v-tabs v-model="tab_index" class="custom-tabs">
                  <v-tab class="component-tab-heading" ripple :href="'#'" @click="changeTab(tab)"
                    style="text-transform:none!important;text-decoration: none;" v-for="(tab, index) in tabs"
                    :key="index">{{ tab }}</v-tab>
                </v-tabs>
                <div class="tag-details-style">
                 <v-row>
                   <v-col cols="12" sm="3">
                       <p>Tag ID</p>
                       <p class="detail-heading">{{ return_items_data.tag_id ? return_items_data.tag_id ? return_items_data.tag_id : return_items_data.tag_number : "-" }}</p>
                   </v-col>
                   <v-col cols="12" sm="3">
                       <p>Article ID</p>
                       <p class="detail-heading">{{ return_items_data.sku_code ? return_items_data.sku_code : "-" }}</p>
                   </v-col>
                   <v-col cols="12" sm="3">
                       <p>Grading Date</p>
                       <p class="detail-heading" v-if="active_tab === 'Service Inspection'">{{ return_items_data.customer_declaration_result?.grader_details ? return_items_data.customer_declaration_result.grader_details.grading_date.split('-').reverse().join('-') : "-" }}</p>
                       <p class="detail-heading" v-else-if="active_tab === 'Packaging & Validation'">{{ return_items_data.grading_result?.grader_details ? return_items_data.grading_result.grader_details.grading_date.split('-').reverse().join('-') : "-" }}</p>
                   </v-col>
                   <v-col cols="12" sm="3">
                       <p>Graded By</p>
                       <p class="detail-heading" v-if="active_tab === 'Service Inspection'">{{ return_items_data.customer_declaration_result?.grader_details ? return_items_data.customer_declaration_result.grader_details.graded_by_name : "-" }}</p>
                       <p class="detail-heading" v-else-if="active_tab === 'Packaging & Validation'">{{ return_items_data.grading_result?.grader_details ? return_items_data.grading_result.grader_details.graded_by_name : "-" }}</p>
                   </v-col>
                   </v-row>
                   <v-row style="margin-top: -18px;">
                   <v-col cols="12" sm="3">
                       <p>Article Description</p>
                       <p class="detail-heading">{{ return_items_data.sku_description ? return_items_data.sku_description : "-" }}</p>
                   </v-col>
                   </v-row>
                   </div>
                   <div style="padding:10px; text-align: center;">
                   <div class="grade-point" v-if="active_tab === 'Service Inspection'"
                   :class="{
                        'accept-grade': return_items_data?.customer_declaration_result?.final_grade === 'Accept',
                        'reject-grade': return_items_data?.customer_declaration_result?.final_grade === 'Reject'
                      }"
                   >{{return_items_data?.customer_declaration_result?.final_grade ? return_items_data.customer_declaration_result.final_grade : "-"}}</div>
                   <div class="grade-point" v-if="active_tab === 'Packaging & Validation'"
                    :class="{
                        'accept-grade': return_items_data?.grading_result?.final_grade === 'Accept',
                        'reject-grade': return_items_data?.grading_result?.final_grade === 'Reject'
                      }"
                   >{{return_items_data?.grading_result?.final_grade ? return_items_data.grading_result.final_grade : "-"}}</div>
                   </div>
                  <!-- Loop over grading_result sections -->
                  <section v-if="active_tab === 'Service Inspection' && return_items_data?.customer_declaration_result?.final_grading_result 
                                && Object.keys(return_items_data.customer_declaration_result.final_grading_result).length">
                  <div v-for="(tests, sectionName) in return_items_data.customer_declaration_result.final_grading_result" :key="sectionName" class="mb-4">
                      <!-- Section title -->
                      <h5 class="font-weight-bold mb-2">
                          {{ formatSectionName(sectionName) }}
                      </h5>

                      <!-- Two-column test/answer layout -->
                      <v-row>
                          <v-col v-for="(testItem, idx) in tests" :key="idx" cols="12" sm="6">
                              <div>{{ testItem.test }}</div>
                              <div class="font-weight-bold">{{ testItem.value || '-' }}</div>
                          </v-col>
                      </v-row>
                  </div>
                  <div>
                  <h5 class="font-weight-bold mb-2">Images & Videos</h5>
                      <v-slide-group v-model="currentIndex" class="py-0" show-arrows center-active>
                          <v-slide-group-item v-for="(imageUrl, index) in mergedImages" :key="index" :value="index" class="thumb-wrapper">
                              <div class="thumb-container" :class="{ 'thumb-active': index === currentIndex }">
                                  <img :src="imageUrl" class="thumb-img" @click="openDialog(index)" />
                              </div>
                          </v-slide-group-item>
                      </v-slide-group>
                  </div>
                  </section>
                  <section class="overflow-y-auto dynamic-height-dis-card overflow-x-hidden" v-else-if="active_tab === 'Packaging & Validation' && return_items_data?.grading_result?.final_grading_result 
                                && Object.keys(return_items_data.grading_result.final_grading_result).length">
                  <div v-for="(tests, sectionName) in return_items_data.grading_result.final_grading_result" :key="sectionName" class="mb-4">
                      <!-- Section title -->
                      <h5 class="font-weight-bold mb-2">
                          {{ formatSectionName(sectionName) }}
                      </h5>

                      <!-- Two-column test/answer layout -->
                      <v-row>
                          <v-col v-for="(testItem, idx) in tests" :key="idx" cols="12" sm="6">
                              <div>{{ testItem.test }}</div>
                              <div class="font-weight-bold">{{ testItem.value.toString() || '-' }}</div>
                          </v-col>
                      </v-row>
                  </div>
                  <div>
                  <h5 class="font-weight-bold mb-2">Images & Videos</h5>
                      <v-slide-group v-model="currentIndex" class="py-0" show-arrows center-active>
                          <v-slide-group-item v-for="(imageUrl, index) in mergedImages" :key="index" :value="index" class="thumb-wrapper" ref="slideGroup">
                              <div class="thumb-container" :class="{ 'thumb-active': index === currentIndex }">
                                  <img :src="imageUrl" class="thumb-img" @click="openDialog(index)"/>
                              </div>
                          </v-slide-group-item>
                       </v-slide-group>
                  </div>
                  </section>
                  <section v-else-if="active_tab === 'Customer Declaration'">
                  <div>
                   <v-row>
                         <v-col v-for="(testItem, idx) in return_items_data.condition_questions" :key="idx" cols="12" sm="6">
                             <div>{{ testItem.question }}</div>
                             <div class="font-weight-bold">{{ testItem.answer }}</div>
                         </v-col>
                      </v-row>
                  </div>
                    <div>
                     <h5 class="font-weight-bold mb-2">Images & Videos</h5>
                      <v-slide-group v-model="currentIndex" class="py-0" show-arrows center-active>
                          <v-slide-group-item v-for="(imageUrl, index) in mergedImages" :key="index" :value="index" class="thumb-wrapper" ref="slideGroup">
                              <div class="thumb-container" :class="{ 'thumb-active': index === currentIndex }">
                                  <img :src="imageUrl" class="thumb-img" @click="openDialog(index)"/>
                              </div>
                          </v-slide-group-item>
                       </v-slide-group>
                    </div>
                  </section>
                  <section v-else>
                  <span>No data found</span>
                  </section>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
        <v-dialog v-model="fullImageShow" persistent max-width="600">
            <v-card>
              <v-card class="v-card-100 mt-0 custom-shadow">
                <v-card-title class="pa-0">
                  <v-row class="ma-2">
                  <span class="font-weight-bold">View Image</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="fullImageShow = false">mdi-close</v-icon>
                </v-row>
                </v-card-title>
               </v-card>
              <v-card-text class="d-flex align-center justify-center">
                <v-btn icon @click="prevImage" :disabled="currentIndex === 0">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <v-img
                  :src="mergedImages[currentIndex]"
                  max-height="80vh"
                  contain
                ></v-img>

                <v-btn
                  icon
                  @click="nextImage(mergedImages[currentIndex])"
                  :disabled="currentIndex === mergedImages.length - 1"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
        
         <!-- Image show popup -->
         <v-dialog v-model="dialogVisible" persistent max-width="600">
          <v-card class="v-card-100 mt-0">
            <v-card-title class="d-flex">
              <span class="headline">Images</span>
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="closeDialog" style="float:right;">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            
            <v-card-text>
              <v-row>
                <v-col v-for="(imageUrl, index) in return_items_data.return_images" :key="index" cols="4">
                  <v-img :src="imageUrl" width="100%" contain></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- Image show popup -->
       <v-dialog v-model="vidoeDialogVisible" persistent max-width="600">
        <v-card class="v-card-100">
          <v-card-title>
            <v-row class="ma-1">
            <span class="headline">Videos</span>
            <v-spacer></v-spacer>
            <!-- <v-btn icon @click="closeDialog"> -->
              <v-icon  @click="closeDialog">mdi-close</v-icon>
            <!-- </v-btn> -->
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col v-for="(videoUrl, index) in return_items_data.return_videos" :key="index" cols="4">
                <video :key="videoUrl" width="100%" controls>
                  <source :src="videoUrl" width="100%" :type="mp4">
                </video>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
        <!--  view error log popup -->
        <v-row justify="center">
        <v-dialog v-model="viewErrorLogPopup" persistent max-width="900px">
          <v-card class="v-card-100">
            <v-card-title>
              <v-row class="ma-1">
              <span>Error Message</span>
              <v-spacer></v-spacer>
              <!-- <v-btn icon @click="viewErrorLogPopup = false"> -->
                <v-icon @click="viewErrorLogPopup = false">mdi-close</v-icon>
              <!-- </v-btn> -->
            </v-row>
            </v-card-title>
            <v-card-text class="text-left">
              <!-- <h6>{{this.error_log_data}}</h6> -->
              <v-row>
              <v-col cols="12" sm="3" md="3">
                <strong>Request Payload :</strong>
              </v-col>
              <v-col cols="12" sm="9" md="9">
                {{this.request_log}}
              </v-col>
              </v-row>
              <v-row>
              <v-col cols="12" sm="3" md="3">
              <strong>Response Payload :</strong>
              </v-col>
              <v-col cols="12" sm="9" md="9">
                {{this.response_log ? this.response_log : this.error_log_data}}
              </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
     <!-- Service Histpory popup -->
     <v-row justify="center">
        <v-dialog v-model="serviceHistoryPopup" persistent max-width="900px">
          <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0 custom-shadow">
            <v-card-title>
              <v-row class="ma-1">
              <span>Service History</span>
              <v-spacer></v-spacer>
                <v-icon @click="serviceHistoryPopup = false">mdi-close</v-icon>
            </v-row>
            </v-card-title>
            </v-card>
            <v-card-text class="text-left">
             <div>
                <v-layout column>
                      <v-data-table 
                        :dense="true"
                        density="compact"
                        :headers="service_history_headers"
                        :items="service_history_items"
                        style="max-height: 300px;height:auto !important;" 
                        disable-pagination
                        return-object 
                        :hide-default-footer="true"
                        :items-per-page="service_history_items.length"
                        class="elevation-1  overflow-auto">
                        <template v-slot:item="{ item }">
                          <div>
                            <span>{{ item.date ? formatDate(item.date) : '-' }}</span>
                            <span>{{ item.reason ? item.reason : '-' }}</span>
                          </div>
                        </template>
                        <template #bottom></template>
                      </v-data-table>                   
                </v-layout>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>

        <v-card class="v-card v-sheet theme--light mt-5 overflow-auto" style="box-shadow:none !important; max-width: 100% !important;" :height="minTableHeight">
          <v-card-text>
            <!-- v-expansion-panels for different sections -->
            <div>
              <div class="p-3">
                <v-row class="p-3 customer-details">
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p >CRM Ticket No</p>
                  <p class="detail-heading">{{ return_items_data.client_crm_ticket_no ? return_items_data.client_crm_ticket_no : "-" }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p>BB Ticket No</p>
                  <p class="detail-heading">{{ return_items_data.bb_ticket_no ? return_items_data.bb_ticket_no : "-" }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p >Sub Request ID</p>
                  <p class="detail-heading">{{ return_items_data.return_sub_request_id ? return_items_data.return_sub_request_id : "-" }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p>Request Creation Date</p>
                  <p class="detail-heading">{{ return_items_data.request_creation_date ? return_items_data.request_creation_date : "-" }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p>Ageing Days</p>
                  <p class="detail-heading">{{ return_items_data.ageing ? return_items_data.ageing + 'Days' : 0 }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p>Created By</p>
                  <p class="detail-heading">{{ return_items_data.customer_name ? return_items_data.customer_name : "-" }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p>Document No</p>
                  <p class="detail-heading" v-if="organization_name == 'Voltas'">-</p>
                  <p class="detail-heading" v-else>{{ return_items_data.reference_document_number ? return_items_data.reference_document_number : "-" }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p>Document Type</p>
                  <p class="detail-heading">{{ return_items_data.reference_document ? return_items_data.reference_document : "-" }}</p>
                </v-col>
              </v-row>
                 <!-- Status And Decision Details -->
                 <div style="margin-top: 30px;"> 
                <v-row class="p-3 customer-details text-left" >
                   <label>Status And Decision Details</label>
                </v-row>
                </div>
                <v-row class="p-3 text-left">
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Purchase Price (₹)</p>
                    <p class="detail-heading" v-if="return_items_data.dealer_purchase_value == 0 && shouldShowActualValue">
                      {{ return_items_data.dealer_purchase_value }}</p>
                    <p class="detail-heading" v-else-if="return_items_data.dealer_purchase_value == null && shouldShowActualValue">{{ "-" }}</p>
                    <p class="detail-heading" v-else>{{ shouldShowActualValue ? return_items_data.dealer_purchase_value : '****' }} </p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Purchase Invoice Date</p>
                    <p class="detail-heading">{{ return_items_data.dealer_purchase_invoice_date ? formatDate(return_items_data.dealer_purchase_invoice_date) : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Customer Invoice Date</p>
                    <p class="detail-heading">{{  return_items_data.purchase_date ? return_items_data.purchase_date : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Depreciation (₹)</p>
                    <p class="detail-heading" v-if="return_items_data.depriciation == 0 && shouldShowActualValue">{{ return_items_data.depriciation }}</p>
                    <p class="detail-heading" v-else-if="return_items_data.depriciation == null && shouldShowActualValue">{{ "-" }}</p>
                    <p class="detail-heading" v-else>{{ shouldShowActualValue ? return_items_data.depriciation : '****' }}
                    <v-tooltip right class="custom-tooltip">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" style="font-size:20px !important; top:-3px !important;" class="ml-2"> mdi-alert-octagon </v-icon>
                        </template>
                        <span>
                          Purchase Date: {{ 
                            shouldShowActualValue 
                            ? (return_items_data.return_type === 'Dealer-Partner Sales Return' 
                                ? formatDate(return_items_data.dealer_purchase_invoice_date) 
                                : return_items_data.purchase_date
                              ) 
                            : '****' 
                          }}<br>
                          Ageing: <span v-if="shouldShowActualValue">{{ return_items_data.depreciation_from || 0 }} - {{ return_items_data.depreciation_to || 0 }}</span><span v-else>****</span><br>
                          Percentage: {{ shouldShowActualValue ? return_items_data.depreciation_percent : '****' }}
                        </span>
                    </v-tooltip>
                  </p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Expected Liquidation Value (₹)</p>
                    <p class="detail-heading" v-if="return_items_data.expected_liquidation == 0">{{ return_items_data.expected_liquidation }}</p>
                    <p class="detail-heading" v-else-if="return_items_data.expected_liquidation == null">{{ "0" }}</p>
                    <p class="detail-heading" v-else>{{ return_items_data.expected_liquidation }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Sub-Request Status</p>
                    <p class="detail-heading">{{ return_items_data.status ? return_items_data.status : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Approval Pending At</p>
                    <p class="detail-heading">{{ return_items_data.approval_pending_from ? return_items_data.approval_pending_from : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Approved By</p>
                    <p class="detail-heading">{{ return_items_data.approved_by ? return_items_data.approved_by : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Customer Resolution Decision</p>
                    <p class="detail-heading">{{ return_items_data.customer_resolution_decision ? return_items_data.customer_resolution_decision : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Customer Resolution Status</p>
                    <p class="detail-heading"> {{ return_items_data.customer_resolution_status ? return_items_data.customer_resolution_status : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Item Decision</p>
                   <!-- <p class="detail-heading">{{ return_items_data.item_decision ? return_items_data.item_decision : "-" }}</p> -->
                  <p class="detail-heading">{{ return_items_data.item_decision ? return_items_data.item_decision[0].toUpperCase() + return_items_data.item_decision.slice(1) : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Item Decision Status</p>
                    <p class="detail-heading"> {{ return_items_data.item_decision_status ? return_items_data.item_decision_status : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>CSE Comment</p>
                    <p class="detail-heading">{{ return_items_data.cse_comments ? return_items_data.cse_comments : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Re-Propose Comment</p>
                    <p class="detail-heading">{{ return_items_data.re_propose_comments ? return_items_data.re_propose_comments : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Recommandation Comment</p>
                    <p class="detail-heading">{{ return_items_data.recommend_comments ? return_items_data.recommend_comments : "-" }}</p>
                  </v-col>
                  <v-col v-if="organization_name !== 'Voltas'" col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Reason</p>
                    <p class="detail-heading">{{ return_items_data.cancellation_reason ? return_items_data.cancellation_reason : "-" }}</p>
                  </v-col>
                  <v-col v-if="organization_name !== 'Voltas'" col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Remarks</p>
                    <p class="detail-heading">{{ return_items_data.remarks ? return_items_data.remarks : "-" }}</p>
                  </v-col>
                  <v-col v-if="organization_name !== 'Voltas'" col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Item Decision History</p>
                    <p><a @click="serviceHistoryOpenDialog()" style="color: #1976d2; cursor: pointer;"><u>View</u></a></p>
                  </v-col>
                </v-row>
                <!-- Customer Entity Details -->
               <div style="margin-top: 30px;">  
               <v-row class="p-3 customer-details">
                  <label>{{ $isWhirlpoolClient() ? 'Customer Details' : "Customer Entity Details" }}</label>
                </v-row>
                </div>
                <v-row class="p-3">
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>{{  $isWhirlpoolClient() ? 'Name' : 'Customer/Entity Name*' }}</p>
                  <p class="detail-heading">{{ return_items_data.main_dealer_name ? return_items_data.main_dealer_name : "-" }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p>{{ $isWhirlpoolClient() ? 'Customer in CRM'  : 'Customer in CRM'}}</p>
                  <p class="detail-heading">{{ return_items_data.dealer_pan ? return_items_data.dealer_pan : "-" }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p>{{ $isWhirlpoolClient() ? 'Type'  : 'Customer/Entity Type'}}</p>
                  <p class="detail-heading">{{ return_items_data.customer_type ? return_items_data.customer_type : "-" }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p>{{ $isWhirlpoolClient() ? 'Contact No*'  : 'Contact Number*'}}</p>
                  <p class="detail-heading">{{ return_items_data.contact_number ? return_items_data.contact_number : "-" }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p>{{ $isWhirlpoolClient() ? 'Alertnate Contact No*'  : 'Alternate Contact Number*'}}</p>
                  <p class="detail-heading">{{ return_items_data.alternate_contact_number ? return_items_data.alternate_contact_number : "-" }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                  <p>Item Location (Address)*</p>
                  <p class="detail-heading">{{ return_items_data.item_location ? return_items_data.item_location : "-" }}</p>
                </v-col>
                <v-col col="12" sm="3" md="3" lg="3" class="text-left">                  
                  <p>Risk Score</p>
                  <p class="detail-heading">{{ return_items_data.risk_score ? return_items_data.risk_score : "-" }}</p>
                </v-col>
                </v-row>

                <!-- Item Details -->
                <v-row class="p-3 customer-details">
                  <label>Item Details</label>
                </v-row>
                <v-row class="p-3">
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Tag ID</p>
                    <p class="detail-heading">{{ return_items_data.tag_id ? return_items_data.tag_id ? return_items_data.tag_id : return_items_data.tag_number : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Article ID</p>
                    <p class="detail-heading">{{ return_items_data.sku_code ? return_items_data.sku_code : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Article Description</p>
                    <p class="detail-heading">{{ return_items_data.sku_description ? return_items_data.sku_description : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" v-if="headerText === 'Dealer/Partner Return Approval'" class="text-left">                    
                    <p>Alternate Contact Number*</p>
                    <p class="detail-heading">{{ return_items_data.alternate_contact_number ? return_items_data.alternate_contact_number : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Serial Number {{ $isWhirlpoolClient() ? '' : '1' }}</p>
                  <p class="detail-heading">{{ return_items_data.serial_number ? return_items_data.serial_number : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Article Id Being Sold On Exchange</p>
                    <p class="detail-heading" v-if="return_items_data.settlement_method === 'Replacement with Return of item'">{{return_items_data.sku_code ? return_items_data.sku_code : "-" }}</p>
                    <p class="detail-heading" v-else>-</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Weight</p>
                     <p class="detail-heading">{{ return_items_data.weight ? return_items_data.weight : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Dimensions</p>
                     <p class="detail-heading">{{ return_items_data.dimension ? return_items_data.dimension : "-" }}</p>
                  </v-col>
                </v-row>

                <!-- Test Details -->
                <v-row class="p-3 customer-details text-left">
                  <label>Test Details</label>
                </v-row>
                <v-row class="p-3 text-left">
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">                    
                    <p>Test Results</p>
                    <p><a @click="viewTestResult()" style="color: #1976d2; cursor: pointer;"><u>View</u></a></p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">                    
                    <p>AI Discrepancy Report</p>
                    <p class="detail-heading">-</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Service Partner</p>
                      <a @click="updateServicePartner" v-if="!return_items_data.service_partner_name">
                      <span style="text-decoration:underline;color:#1976d2; cursor: pointer;">Update</span>
                    </a>
                    <a @click="updateServicePartner" v-else>
                      <p class="detail-heading" style="text-decoration:underline; cursor: pointer; color:#1976d2 !important;">{{ return_items_data.service_partner_name ? return_items_data.service_partner_name : "-" }}</p>
                    </a>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Service Technician</p>
                    <a @click="updateServiceTechnician" v-if="!return_items_data.service_technician_name">
                      <span style="text-decoration:underline;color:#1976d2; cursor: pointer;">Update</span>
                    </a>
                    <a @click="updateServiceTechnician" v-else>
                      <p class="detail-heading" style="text-decoration:underline; cursor: pointer; color:#1976d2 !important;">{{ return_items_data.service_technician_name ? return_items_data.service_technician_name : "-" }}</p>
                    </a>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Service Ticket Number</p>
                    <p class="detail-heading">{{ return_items_data.service_ticket_number ? return_items_data.service_ticket_number : '-' }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Validation Status</p>
                    <p class="detail-heading">{{ return_items_data.policy ? return_items_data.policy : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Item condition</p>
                    <p class="detail-heading">{{ return_items_data.repairable_status ? return_items_data.repairable_status : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">                    
                    <p>Grading Details</p>
                    <p>
                        <a 
                          v-if="checkGradingDetails"
                          @click="viewPackaging"
                          style="color: #1976d2; cursor: pointer;">
                          <u>View All</u>
                        </a>
                        <span v-else
                              style="color: #aaa; cursor: not-allowed;">
                          <u>View All</u>
                        </span>
                      </p>
                  </v-col>
                </v-row>

                <!-- Customer Declaration Details -->
                <v-row class="p-3 customer-details">
                  <label>Customer Declaration</label>
                </v-row>
                <v-row class="p-3">
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Issue Reported</p>
                    <p class="detail-heading">{{ return_items_data.issue_reported ? return_items_data.issue_reported : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Type of damage</p>
                    <p class="detail-heading">{{ return_items_data.type_of_incident_or_damage ? return_items_data.type_of_incident_or_damage : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>{{ $isWhirlpoolClient() ? 'Vendor Induced' : 'Vendor Responsible for Damage'}}</p>
                    <p class="detail-heading">{{ return_items_data.vendor_responsible ? return_items_data.vendor_responsible : "-" }}</p>
                  </v-col>
                  
                  <v-col col="12" :sm="$isWhirlpoolClient() ? '3' : '3'" :md="$isWhirlpoolClient() ? '3' : '3'" :lg="$isWhirlpoolClient() ? '3' : '3'" class="text-left">
                    <p>Condition Questions</p>
                    <p class="detail-heading">-</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Images</p>
                    <a @click="viewCustomerDeclarationImages(return_items_data)" v-if="return_items_data.return_images != ''">
                      <span style="text-decoration: underline; cursor: pointer;  color:#1976d2;">View All</span>
                    </a>
                    <p class="detail-heading" v-else>-</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Videos return file</p>
                    <a @click="viewVideosReturnFile" v-if="return_items_data.return_videos != ''"><span style="text-decoration: underline;color:#1976d2;">View All</span></a>
                    <p class="detail-heading" v-else>-</p>
                  </v-col>
                </v-row>

                <!-- Other Details -->
                <v-row class="p-3 customer-details">
                  <label>Other Details</label>
                </v-row>
                <v-row class="p-3">
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Channel</p>
                    <p class="detail-heading">{{ return_items_data.channel ? formatResponse(return_items_data.channel) : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Return Sub-Type</p>
                    <p class="detail-heading">{{ return_items_data.return_request_sub_type ? formatResponse(return_items_data.return_request_sub_type) :
                      "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Return Reason</p>
                    <p class="detail-heading">{{ return_items_data.return_reason ? formatResponse(return_items_data.return_reason) : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Return Sub-Reason</p>
                    <p class="detail-heading">{{ return_items_data.return_sub_reason ? formatResponse(return_items_data.return_sub_reason) : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Branch</p>
                    <p class="detail-heading">{{ return_items_data.branch ? formatResponse(return_items_data.branch) : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Region</p>
                    <p class="detail-heading">{{ return_items_data.region ? formatResponse(return_items_data.region) : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Zone</p>
                    <p class="detail-heading">{{ return_items_data.zone ? formatResponse(return_items_data.zone) : "-" }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Sales Manager</p>
                    <p class="detail-heading">-</p>
                    <!-- <p class="detail-heading">{{ return_items_data.sales_manager ? formatResponse(return_items_data.sales_manager) : "-" }}</p> -->
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>{{ $isWhirlpoolClient() ? 'Customer Service Executive' : 'Ticket Initiator' }}</p>
                    <p class="detail-heading">{{ return_items_data.customer_service_executive ? formatResponse(return_items_data.customer_service_executive)
                    : "-"}}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Repair Partner</p>
                    <p class="detail-heading">-</p>
                    <!-- <p class="detail-heading">{{ formatResponse(return_items_data.repair_partner) }}</p> -->
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Repair Executive</p>
                    <p class="detail-heading">-</p>
                    <!-- <p class="detail-heading">{{ formatResponse(return_items_data.repair_executive) }}</p> -->
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Grading Partner</p>
                    <p class="detail-heading">-</p>
                    <!-- <p class="detail-heading">{{ formatResponse(return_items_data.grading_partner) }}</p> -->
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" v-if="$isWhirlpoolClient()" class="text-left">
                    <p>Granding By</p>
                    <p class="detail-heading">-</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">                    
                    <p>Grading Executive</p>
                    <p class="detail-heading">-</p>
                    <!-- <p class="detail-heading">{{ formatResponse(return_items_data.grading_executive) }}</p> -->
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">
                    <p>Request Creation Date</p>
                    <p class="detail-heading">{{ formatResponse(return_items_data.request_creation_date) }}</p>
                  </v-col>
                  <v-col col="12" sm="3" md="3" lg="3" class="text-left">                    
                    <p>Ageing</p>
                    <p class="detail-heading" v-if="return_items_data.ageing == 0">{{ return_items_data.ageing + ' Days' }}</p>
                    <p class="detail-heading" v-else-if="return_items_data.ageing == null">{{ "-" }}</p>
                    <p class="detail-heading" v-else>{{ return_items_data.ageing + ' Days'}}</p>
                  </v-col>
                </v-row>

               
                 <!-- API Integration -->
              <v-row class="p-3 customer-details">
                <label>API Integration</label>
              </v-row>
              <v-row class="p-3">
                <v-data-table 
                  :dense="true"  
                  density="compact"
                  v-model="selected" 
                  disable-pagination 
                  :hide-default-footer="true"
                  :headers="headers"
                  :items="table_data" 
                  :loading="loading" 
                  fixed-header
                  height="100%"
                  return-object
                  loading-text="Loading Data... Please wait"
                  class="elevation-1" style="width:100%;box-shadow: none !important;">
                  
                  <template #[`item.request_type`]="{ item }">
                    <span v-if="item.request_type == 'PUSH' || item.request_type == 'push'">Outbound</span>
                    <span v-else-if="item.request_type == 'pull'">Inbound</span>
                    <span v-else>-</span>
                  </template>
                  <template #[`item.status`]="{ item }">
                    <span v-if="item.status == 'failed'">Failed</span>
                    <span v-else-if="item.status == 'completed' || item.status == 'success'">Success</span>
                    <span v-else>-</span>
                  </template>
                  <template #[`item.error_string`]="{ item }">
                    <a @click="itemDetailpopup(item)" style="color: #1976d2; cursor: pointer !important;">
                      <u>View</u>
                    </a>
                    <!-- <span v-else>-</span> -->
                  </template>
                  <template #[`item.re_trigger`]="{ item }">
                    <v-btn
                      v-if="
                        (item.request_type.toLowerCase() === 'push' && (item.status.toLowerCase() === 'completed' || item.status.toLowerCase() === 'success')) ||
                        ((item.request_type.toLowerCase() === 'push' && item.status.toLowerCase() === 'failed') || 
                        (item.request_type.toLowerCase() === 'pull' && item.status.toLowerCase() === 'failed'))
                      "
                      class="m-2"
                      label="RE-TRIGGER"
                      :disabled="!item.enable_retrigger"
                      variant="outlined"
                      color="primary"
                      @click="retrigger(item)">
                      RE-TRIGGER
                    </v-btn>
                    <span v-else-if="!(item.request_type.toLowerCase() === 'push' && item.status.toLowerCase() === 'success') || !(item.request_type.toLowerCase() === 'pull' && item.status.toLowerCase() === 'success')">-</span>
                  </template>
                  <template #bottom></template>
                </v-data-table>
              </v-row>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-card>
  </template>
  <script>
  import $ from 'jquery';
  import HeaderComponent from '../../../commoncomponents/HeaderComponent.vue';
  import Loading from 'vue-loading-overlay';
  export default {
    components: {
      HeaderComponent,
    },
    data() {
      return {
        headerText: "Return Creation",
        ReturnCreationRia: true,
        search_tag: '',
        IrrdDetails: true,
        updatepopinitem: false,
        isLoading: false,
        datadetailpopuptestresults: false,
        alert: false,
        successpopup: false,
        technician_flag: false,
        dialogVisible: false,
        vidoeDialogVisible: false,
        successmessage: '',
        alert_type: "success",
        alert_message: "",
        panel: [],
        assign_to: '',
        assign_to_technician: '',
        assign_to_items: [],
        assign_to_technician_list: [],
        assign_to_items_list: [],
        return_items_data: [],
        page: 1,
        pageSize: 25,
        pageSizes: [25, 50, 75, 100],
        totalPages: 1,
        action_title: '',
        return_sub_request_id: '',
        crm_ticket_number: '',
        partner_flag: false,
        parent_id: '',
        item_detail: null,
        asm_id: '',
        currentUser:'',
        minTableHeight: "200px",
        organization_name: '',
        headers:[
        { title: "API Instance", key: "payload_type",  sortable: false },
        { title: "API Method", key: "request_type", sortable: false},
        { title: "API Status", key: "status", sortable: false },
        { title: "Error Message", key: "error_string", sortable: false },
        { title: "", key: "re_trigger", sortable: false }
      ],
      table_data: [],
      selected: [],
      viewErrorLogPopup: false,
      error_log_data: '',
      request_log: '',
      response_log: '',
      isServicePartDis : false,
      isServiceTechnDis : false,
      isViewDisabled : false,
      action_from_reslogi:'',
      serviceHistoryPopup: false,
      packagingConditionPopup: false,
      service_history_headers: [
        { title: "Date", key: "date", width: "120" },
        { title: "Trip ID", key: "trip_id"},
        { title: "FTA Logistics FTA ID", key: "lr_id",width: "200" },
        { title: "Activity Type", key: "activity_type" },
        { title: "Status", key: "status",width: "120" },
        { title: "Reason", key: "reason" }
      ],
      service_history_items: [],
      showAllImages: false,
      currentIndex: 0,
      tabs: ["Service Inspection", "Packaging & Validation"],
      active_tab: "Service Inspection",
      tab_index: 0,
      fullImageShow: false,
      imageUrlsmerged: [],
      }
    },
    async created() {
      this.action = this.$store.state.action;
      this.action_from_reslogi = this.$store.state.actionRequest
      this.organization_name = this.$store.state.organization_name;
      const item_detail = JSON.parse(this.$store.state.items);
      this.item_detail = item_detail
      if(this.action_from_reslogi == 'Reverse Logistics' || this.action_from_reslogi == 'FTA'){
        this.return_sub_request_id = item_detail.return_sub_request_id ? item_detail.return_sub_request_id : item_detail.ticket_number;
        this.headerText = this.action_from_reslogi
      }else{
        this.return_sub_request_id = item_detail.sub_request_id;
      }
      this.crm_ticket_number = item_detail.crm_ticket_number;
      this.currentUser = this.$store.state.currentUser.roles[0];
      this.action_title = 'Returns / Claim Requests'
      this.loadData(item_detail);
      if(this.organization_name === "Blubirch"){
        this.tabs.unshift("Customer Declaration")
        this.active_tab = "Customer Declaration";
      }
    },
    mounted() {
      this.calculateTableHeight();
      window.addEventListener('resize', this.calculateTableHeight);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.calculateTableHeight);
    },
    computed: {
      checkGradingDetails() {
          return this.return_items_data?.grading_result?.final_grading_result 
                 && Object.keys(this.return_items_data.grading_result.final_grading_result).length || this.return_items_data?.customer_declaration_result?.final_grading_result 
                                && Object.keys(this.return_items_data.customer_declaration_result.final_grading_result).length || this.return_items_data?.condition_questions?.length
        
      },
      mergedImages() {
         const results = this.active_tab === 'Service Inspection' ? this.return_items_data?.customer_declaration_result?.final_grading_result : this.return_items_data?.grading_result?.final_grading_result || {};
          let urls = [];

          Object.values(results).forEach(testArray => {
            testArray.forEach(test => {
              if (Array.isArray(test.imageHolder)) {
                test.imageHolder.forEach(imgObj => {
                  if (imgObj.imageSrc) urls.push(imgObj.imageSrc);
                  if (imgObj.originalImageSrc) urls.push(imgObj.originalImageSrc);
                  if (imgObj.annotatedImageSrc) urls.push(imgObj.annotatedImageSrc);
                });
              }
            });
          });
          this.imageUrlsmerged =  urls;
         let uniqueUrls = this.active_tab === 'Customer Declaration' ?  [...new Set(this.return_items_data?.return_images)] : [...new Set(urls)];
          return uniqueUrls;
        },
      shouldShowActualValue() {
        return this.currentUser === 'branch_sales_manager' ||
          this.currentUser === 'regional_business_head' ||
          this.currentUser === 'product_head' ||
          this.currentUser === 'branch_finance_manager' ||
          this.currentUser === 'regional_finance_manager';
      },
      formattedAssignToItemsList() {
        return this.assign_to_items_list.map(item => ({
          ...item,
          displayText: `${item.first_name} ${item.last_name ? item.last_name : ''} ${item.employee_code ? '(' + item.employee_code + ')' : ''}`
        }));
      }
    },
    methods: {
      changeTab(tab) {
        this.active_tab = tab;
      },
      calculateTableHeight() {
        const viewportHeight = window.innerHeight;
        if(this.headerText === 'Reverse Logistics'){
          this.minTableHeight = (viewportHeight - 130) + 'px'
        }else{
        this.minTableHeight = (viewportHeight - 130) + 'px'
        }
      },
      formatResponse(response) {
        return response ? response.replace(/_/g, ' ') : "-";
      },
      closeItempopup(){
        this.updatepopinitem = false;
        this.assign_to = '';
      },
      loadData(item){
        this.isLoading = true;
        if ((item.stage === "Request") || (this.action_from_reslogi == 'Reverse Logistics' || this.action_from_reslogi == 'FTA')) {
          var return_item1 = "return_item"
        }else{
          var return_item1 = "return_item_ticket"
        }
        const params = {
          return_item_type: return_item1
        }
        this.$httpSecured
          .get(`/api/v1/warehouse/return_initiation/return_creations/${item.id}?`, { params: params })
          .then(response => {
            if (response.data) {
              this.return_items_data = response.data.return_item;
              this.checkUpdateServicePartnerDisablity()
              this.checkUpdateServiceTechnDisablity()
              this.checkViewDisabled()
              this.isLoading = false;
            } else {
              this.isLoading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.isLoading = false;
          });
          this.serviceHistoryAPI();
          if(this.organization_name === 'Voltas'){
            this.apiIntegration();
            }
          },
          apiIntegration(){
            this.$httpSecured
            .get(`/api/v1/warehouse/return_initiation/return_creations/${this.item_detail.id}/api_payloads`)
            .then(response => {
                if (response.data) {
                  this.table_data = response.data.api_payloads;
                  this.isLoading = false;
                } else {
                  this.isLoading = false;
                  this.showAlert("error", "No Data Found");
                }
              })
              .catch(error => {
                this.isLoading = false;
              });
          },
          itemDetailpopup(item) {
            this.error_log_data = item.error_string ? item.error_string.error_message ? item.error_string.error_message : item.error_string['Error Message'] : "No error message available";
            this.request_log = item.request_payload;
            this.response_log = item.response_payload;
            this.viewErrorLogPopup = true;
          },
          retrigger(item) {
            this.$httpSecured
              .put(`/api/v1/warehouse/return_initiation/return_creations/${item.id}/retry_api_payload `)
              .then(response => {
                if (response.data) {
                  this.$toast.success(response.data.message);
                  this.apiIntegration();
                  this.loading = false;
                } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
                }
              })
              .catch(error => {
                this.showAlert('error', error.response.data.message);
                this.loading = false;
              });
              },
            
        viewTestResult() {
        this.datadetailpopuptestresults = true;
      },
      formatDate(dateString) {
        if (!dateString) return ''; // Return empty string if dateString is null
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // January is 0
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
      closedatadetailpopuptestresults() {
        this.datadetailpopuptestresults = false;
        this.technician_flag = false;
        this.partner_flag = true;
        this.assignServicePartner();
      },
      updateServicePartner() {
        this.updatepopinitem = true;
        this.technician_flag = false;
        this.partner_flag = true
        this.assign_to = '';
       if(this.currentUser === 'area_service_manager'){
        this.checkUpdateServicePartnerDisablity()
        }else{
          this.assignServicePartner();
        }
      },
      updateServiceTechnician() {
        this.updatepopinitem = true;
        this.partner_flag = false;
        this.assign_to = '';
        this.parent_id = this.return_items_data.service_partner_id ? this.return_items_data.service_partner_id : '';
        this.asm_id = this.return_items_data.user_id ? this.return_items_data.user_id : '';
        if(!this.return_items_data.service_partner_name){
          this.technician_flag = false;
        }else {
          this.technician_flag = true;
        }

        this.assignServicePartner();
      },
      viewCustomerDeclarationImages() {
        this.dialogVisible = true;
      },
      viewVideosReturnFile() {
        // this.dialogVisible = true;
        this.vidoeDialogVisible = true;
      },
      closeDialog(){
        this.dialogVisible = false;
        this.vidoeDialogVisible = false;
      },

      assignServicePartner(){
        let requestBody = [];
        if(this.partner_flag === true){
          requestBody = {
            only_partner: true,
            asm_id: this.asm_id,
            query: this.assign_to,
          }
        }else {
          if(!this.parent_id){
            requestBody = {
              only_technician: true,
              parent_id: this.parent_id,
              asm_id: this.asm_id,
              query: this.assign_to,
            }
          }else {
            requestBody = {
              parent_id: this.parent_id,
              asm_id: this.asm_id,
              query: this.assign_to,
            }
          }
          
        }
        this.$httpSecured
        .get("/api/v1/warehouse/return_initiation/return_creations/service_partners?", { params: requestBody })
        .then(response => {
          if (response.data) {
            this.assign_to_items_list = response.data.users;
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.isLoading = false;
        });
      },

      updateTechnician() {
        const item_id = this.return_items_data.id
        const requestData = {
          user_id: this.assign_to.id,
          return_type: this.return_items_data.stage === 'Request' ? 'return_item' : 'return_item_ticket'
        }
        this.$httpSecured
        .put(`/api/v1/warehouse/return_initiation/return_creations/${item_id}/update_technician_name`, requestData)
        .then((response) => {
          if (response.data) {
            this.updatepopinitem = false;
            this.successpopup = true;
            this.successmessage = response.data.message;
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message);
          this.loading = false;
        });
      },
      createServiceRequest() {
        let skip_ticket;
        if(this.item_detail.is_crm_outbounded === true){
          skip_ticket = true;
        }else{
          skip_ticket = false;
        }
        const requestData = {
          user_id: this.assign_to.id,
          crm_ticket_numbers: this.crm_ticket_number,
          skip_ticket: skip_ticket
        }
        this.$httpSecured
        .post("/api/v1/warehouse/return_initiation/return_creations/create_service_request", requestData)
        .then((response) => {
          if (response.data) {
            this.updatepopinitem = false;
            this.assign_to = ''
            this.successpopup = true;
            this.successmessage = response.data.message;
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.$toast.error(error.response.data.error);
          this.loading = false;
          this.edit_assign_selected = [];
          this.selected = [];
        });
      },
      afterClickOkLoadData() {
        if (!this.item_detail) return;
        this.successpopup = false;
        this.successmessage = ''
        this.loadData(this.item_detail);
      },
      checkUpdateServicePartnerDisablity(){
      let requestBody = {
          only_partner: true,
          asm_id: this.return_items_data.user_id ? this.return_items_data.user_id : '',
          query: '',
        }
      this.$httpSecured
      .get("/api/v1/warehouse/return_initiation/return_creations/service_partners?", { params: requestBody })
      .then(response => {
        this.isServicePartDis = response.data.users.length == 0;
         this.assign_to_items_list = response.data.users;
      })
      .catch(error => {
        this.showAlert("error", "Something went wrong from Network" + error);
      });
    },
    checkUpdateServiceTechnDisablity(){
      let requestBody;
      requestBody = {
        only_technician: true,
        parent_id: this.return_items_data.service_partner_id ? this.return_items_data.service_partner_id : '',
        asm_id:  this.return_items_data.user_id ? this.return_items_data.user_id : '',
        query: '',
      }
      this.$httpSecured
      .get("/api/v1/warehouse/return_initiation/return_creations/service_partners?", { params: requestBody })
      .then(response => {
        this.isServiceTechnDis = response.data.users.length == 0;
      })
      .catch(error => {
        this.showAlert("error", "Something went wrong from Network" + error);
      });
    },
    checkViewDisabled(){
      this.isViewDisabled = !(this.return_items_data.ticket_resolution || this.return_items_data.item_decision || this.return_items_data.condition_questions || 
             this.return_items_data.estimated_service_cost || this.return_items_data.type_of_defect || this.return_items_data.service_partner_name ||
             (this.return_items_data.defective_spare_part_info && this.return_items_data.defective_spare_part_info.length))
    },
    serviceHistoryOpenDialog(){
      this.serviceHistoryPopup = true
    },
    serviceHistoryAPI(){
        this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/return_creations/logistic_activities?id=${this.item_detail.id}`)
        .then(response => {
            if (response.data) {
              this.service_history_items = response.data.data;
              this.isLoading = false;
            } else {
              this.isLoading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.isLoading = false;
          });
      },
      viewPackaging(){
        this.packagingConditionPopup = true;
        // Packaging Condition
        // Physical Condition
        // Functional Condition
        // Accessories
      },
      formatSectionName(name) {
        // Convert "Physical Condition" → "Physical"
        return name.replace(' Condition', '');
      },
    openDialog(index) {
      this.currentIndex = index;
      this.fullImageShow = true;
    },
     prevImage() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
        }
      },
      nextImage(val) {
        if (this.currentIndex < this.mergedImages.length - 1) {
          this.currentIndex++;
        }
      }
    }
  }

  </script>
  <style scoped>
  .fw-600 {
    font-weight: 600;
  }
  
  .fw-500 {
    font-weight: 500;
  }
  
  .fs-md {
    font-size: medium;
  }
  .customer-details {
    background-color: #EAF4FF;
  }
  .customer-details label {
    color: #002F9E;
    font-weight: 600;
    font-size: 18px;
  }
  .detail-heading {
    font-weight: 600;
    color: #2D2D2D;
    font-size: 14px;
  }
  .v-tooltip__content {
  background-color: white !important; 
  color: black !important;           
  border: 1px solid #ccc;            
  padding: 10px;                     
  font-size: 14px;                  
  }
  .disabled_span {
    pointer-events: none; 
    opacity: 0.5;
    color: gray;
  }
  .thumb-wrapper {
    flex: 0 0 auto !important;
    margin-right: 8px;
  }

  .thumb-container {
    width: 90px;
    height: 95px;
    border-radius: 12px !important;   /* 🔒 Ensures radius on container */
    overflow: hidden;
    cursor: pointer;
    border: 2px solid transparent;
    box-sizing: border-box;
  }

  .thumb-img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
    border-radius: 12px !important;   /* 🔒 Force radius on image too */
  }
  ::v-deep(.v-slide-group__container .v-slide-group__content) {
    display: flex !important;
    justify-content: left !important;
    align-items: left !important;
  }
  .v-btn__content{
    font-size: 16px !important;
  }
  .media-content {
    max-width: 300px;
    max-height: 400px;
    width: auto;
    height: auto;
    object-fit: contain;
    border-radius: 8px;
  }
  :deep(.custom-tabs .v-tab--selected) {
      text-transform: none;
      color: #002F9E;
      height: 36px !important;
      background-color:#E1F1FF !important;
      font-size: 12px;
      font-weight: 500 !important;
      line-height: 16.8px !important;
  }
  .tag-details-style{
    background-color: #EAF4FF;
    border-radius: 8px;
    padding: 10px;
  }
  .grade-point{
    width: 80px;
    padding: 7px;
    position: relative;
    left: 41%;
    font-weight: 600;
  }
  .dynamic-height-dis-card {
    height: calc(var(--vh, 1vh) * 100 - 500px) !important;
  }
  .accept-grade {
    background: #E1FAE1;
    color: #157F15;
  }

  /* Reject */
  .reject-grade {
    background: #FDEAEA;
    color: #C62828;
  }

  </style>